export default class IssueExtensions {
    static getForceToChange = issues => issues.map(x => x.field.warning).filter(x => x && x.type === 0);

    static getWarnings = issues => issues.map(x => x.field.warning).filter(x => x && x.type === 1);

    static hasForceToChange = issues => IssueExtensions.getForceToChange(issues).length > 0;

    static hasWarnings = issues => IssueExtensions.getWarnings(issues).length > 0;
}